import { render, staticRenderFns } from "./ChangeTGModal.vue?vue&type=template&id=3a62d2a2&scoped=true"
import script from "./ChangeTGModal.vue?vue&type=script&lang=ts"
export * from "./ChangeTGModal.vue?vue&type=script&lang=ts"
import style0 from "./ChangeTGModal.vue?vue&type=style&index=0&id=3a62d2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62d2a2",
  null
  
)

export default component.exports